import { Grid } from "@material-ui/core";
import { Block, Done } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { formatMoney, isRoleisBalanceLockOverride } from "app/common/LocalFunction";
import { getByKeyCode } from "app/services/SystemConfigService";
import { pagingDepartment } from "app/services/StoreRequestService";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
function LockRetainedPopup({
  open,
  handleClose,
  onConfirm,
  initialValues,
  handleAfterSubmit,
}) {
  // console.log("initialValues", initialValues);
  const defaultDepartment = useDefaultDepartment();
  const isRoleBalanceLockOverride = isRoleisBalanceLockOverride();
  const [disableEditRetainedAmountConfig, setDisableEditRetainedAmountConfig] =
    useState(false);

  useEffect(() => {
    getByKeyCode("DISABLE_EDIT_RETAINED_AMOUNT")
      .then(({ data }) => {
        setDisableEditRetainedAmountConfig(
          data?.configValue === "true" || data?.configValue === true
        );
      })
      .catch(() => setDisableEditRetainedAmountConfig(false));
  }, []);

  const disableRetainedAmount =
    disableEditRetainedAmountConfig && !isRoleBalanceLockOverride;

  return (
    <PopupForm
      size="sm"
      open={open}
      handleClose={handleClose}
      title="Khóa và lưu trữ số dư"
      formik={{
        initialValues: { ...initialValues, department: defaultDepartment },
        enableReinitialize: true,

        validationSchema: Yup.object({
          // retainedAmount: Yup.number()
          //   .test(
          //     "validate-retainedAmount",
          //     "Không được vượt quá số tiền thanh toán !",
          //     function (value) {
          //       if (value > initialValues?.totalBillPatientPaid) return false;
          //       return true;
          //     }
          //   )
          //   .nullable(),
          retainedAmount: isRoleBalanceLockOverride
            ? Yup.number().nullable()
            : Yup.number()
              .test(
                "validate-retainedAmount",
                "Không được vượt quá số tiền thanh toán !",
                function (value) {
                  if (value > initialValues?.totalBillPatientPaid) return false;
                  return true;
                }
              )
              .nullable(),
        }),

        onSubmit: async (values, { setSubmitting }) => {
          await onConfirm(values, { setSubmitting });
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        },
      }}
      action={(values, isSubmitting) => {
        return (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" />
              Hủy
            </CommonButton>
            <CommonButton
              type="submit"
              className="btn-danger"
              disabled={isSubmitting}
            >
              <Done className="mr-2" />
              Xác nhận
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values, isSubmitting }) => {
        return (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    Tên dịch vụ:{" "}
                    {values?.service?.name ||
                      values?.drug?.name ||
                      values?.clientCard?.name ||
                      ""}
                  </Grid>
                  {values?.service && (
                    <Grid item xs={6}>
                      Đã điều trị: {values?.totalPerformedTimes}
                    </Grid>
                  )}
                  <Grid item xs={6}>
                    Số tiền đã thanh toán:{" "}
                    {formatMoney(values?.totalBillPatientPaid)}
                  </Grid>
                  <Grid item xs={6}>
                    Cần thanh toán: {formatMoney(values?.amountActuallyPaid)}
                  </Grid>
                </Grid>
              </Grid>
              {/* dịch vụ gì; số tiền đã thanh toán; cần thanh toán; số buổi đã điều trị */}
              <Grid item xs={12} className="flex flex-center">
                <strong style={{ color: "red" }}>
                  Số tiền lưu trữ phải nhỏ hơn hoặc bằng số tiền đã thanh toán
                </strong>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <GlobitsPagingAutocomplete
                  api={pagingDepartment}
                  name={"department"}
                  label="Cơ sở"
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={6} className="flex gap-2 align-end">
                <GlobitsVNDCurrencyInput
                  name={"retainedAmount"}
                  label="Tiền lưu trữ"
                  disabled={disableRetainedAmount}
                />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(LockRetainedPopup));
